import { IFieldSetPartial } from '../../../lib/mighty-fields';

/**
 * The case itself. The account it belongs to is left off: the tab is reached through that account,
 * and moving a case to another one is not something the page offers.
 *
 * Only the plaintiff is required. A case is often opened here from a firm's own list before the
 * docket number is known, and a resolution is what a closed case has -- an open one has none.
 */
const CASE_FIELD_SETS: IFieldSetPartial[] = [
  [
    { field: 'plaintiff_full_name', label: 'Plaintiff', required: true },
    { field: 'court_id', label: 'Court Docket / Index Number' },
    // Resolutions come back as raw enum values; their labels live in the option list served by
    // /options/, as the account's own type and status do.
    {
      field: 'resolution',
      optionKey: 'value',
      optionType: 'loanCollateralCaseResolutionOptions',
      type: 'optionSelect',
    },
  ],
  [
    { field: 'notes', type: 'textDynamic' },
  ],
]

  // What a new update says and who said it. The date is the day the update is about rather than the
  // day it was entered, which is why it is asked for rather than stamped.
  , CASE_UPDATE_FIELD_SETS: IFieldSetPartial[] = [
    [
      {
        field: 'source',
        optionKey: 'value',
        optionType: 'loanCollateralCaseUpdateSourceOptions',
        required: true,
        type: 'optionSelect',
      },
      { field: 'update_date', label: 'Date', required: true, type: 'date' },
    ],
    [
      { field: 'body', label: 'Update', required: true, type: 'textDynamic' },
    ],
  ];

export { CASE_FIELD_SETS, CASE_UPDATE_FIELD_SETS };
